import {
    min, max, required, contactDetails,
} from '../services/validators';
import AutoQuoteForm from '~/components/business/form/AutoQuoteForm.vue';
import CoverageAreaForm from '~/components/business/form/CoverageAreaForm.vue';
import BusinessDetailsForm from '~/components/business/form/BusinessDetailsForm.vue';
import LicenceForm from '~/components/business/form/LicenceForm.vue';
import ServicesForm from '~/components/business/form/ServicesForm.vue';
import UserForm from '~/components/user/UserForm.vue';

export default {
    data() {
        return {
            addressLine1: '',
            addressLine2: '',
            agency: 'ea',
            auto_quote_grab_bag_lead: '3to5',
            auto_quote_grab_bag_message: '',
            auto_quote_skip_lead: '3to5',
            auto_quote_skip_message: '',
            business_name: '',
            categories: [],
            contact_number: '',
            contact_number_2: '',
            description: '',
            vat: '',
            displayAddressPublically: true,
            lat: 0,
            lon: 0,
            locations: [],
            logo: [],
            nationwide: false,
            postcode: '',
            reg_no: '',
            services: [],
            showUserStep: false,
            url: '',
        };
    },
    computed: {
        steps() {
            const steps = [
                {
                    name: 'business',
                    title: this.$t('business.form.enter_details'),
                    component: BusinessDetailsForm,
                    props: {
                        existingLogo: this.existingLogo,
                    },
                },
                {
                    name: 'area',
                    title: this.$t('business.form.enter_coverage'),
                    component: CoverageAreaForm,
                    props: {
                        business: this.business,
                    },
                },
                { name: 'licence', title: this.$t('business.form.enter_licence'), component: LicenceForm },
                { name: 'services', title: this.$t('business.form.select_services'), component: ServicesForm },
            ];

            if (this.services.includes(2) || this.services.includes(3)) {
                steps.push({
                    name: 'auto',
                    title: this.$t('business.form.select_auto_quote_settings'),
                    component: AutoQuoteForm,
                    props: {
                        autoQuotes: this.autoQuotes,
                    },
                });
            }

            if (this.showUserStep) {
                steps.push({
                    name: 'user',
                    component: UserForm,
                    props: {
                        disableRedirect: true,
                        showMobileNumber: true,
                    },
                });
            }

            return steps;
        },
    },
    methods: {
        buildAutoQuoteArray() {
            return [
                {
                    active: this.auto_quote_grab_bag_enabled,
                    message: this.auto_quote_grab_bag_message,
                    delivery: this.auto_quote_grab_bag_lead,
                    service_id: 3,
                    prices: [
                        { price: this.auto_quote_grab_bag_sm, size: 'sm' },
                        { price: this.auto_quote_grab_bag_md, size: 'md' },
                        { price: this.auto_quote_grab_bag_lg, size: 'lg' },
                    ],
                },
                {
                    active: this.auto_quote_skip_enabled,
                    message: this.auto_quote_skip_message,
                    delivery: this.auto_quote_skip_lead,
                    service_id: 2,
                    prices: [
                        { price: this.auto_quote_skip_2yd, size: '2yd' },
                        { price: this.auto_quote_skip_4yd, size: '4yd' },
                        { price: this.auto_quote_skip_6yd, size: '6yd' },
                        { price: this.auto_quote_skip_8yd, size: '8yd' },
                        { price: this.auto_quote_skip_12yd, size: '12yd' },
                        { price: this.auto_quote_skip_roll, size: 'roll' },
                    ],
                },
            ];
        },
    },
    validations: {
        addressLine1: [
            required,
            { validator: max, length: 250 },
        ],
        addressLine2: [
            { validator: max, length: 250 },
        ],
        agency: [],
        auto_quote_grab_bag_enabled: [],
        auto_quote_grab_bag_sm: [],
        auto_quote_grab_bag_md: [],
        auto_quote_grab_bag_lg: [],
        auto_quote_grab_bag_message: [],
        auto_quote_grab_bag_lead: [],
        auto_quote_skip_enabled: [],
        auto_quote_skip_2yd: [],
        auto_quote_skip_4yd: [],
        auto_quote_skip_6yd: [],
        auto_quote_skip_8yd: [],
        auto_quote_skip_12yd: [],
        auto_quote_skip_roll: [],
        auto_quote_skip_message: [],
        auto_quote_skip_lead: [],
        business_name: [
            required,
            { validator: min, length: 1 },
            { validator: max, length: 150 },
        ],
        description: [
            contactDetails,
            { validator: min, length: 5 },
            { validator: max, length: 20000 },
        ],
        vat: [
            required,
        ],
        displayAddressPublically: [],
        lat: [
            { validator: required, message: 'addresses.not_recognised' },
        ],
        lon: [],
        locations: [],
        logo: [],
        nationwide: [],
        postcode: [
            required,
            { validator: max, length: 10 },
        ],
        categories: [],
        services: [{ validator: required, message: 'waste_removal.select_service' }],
        contact_number: [
            required,
            { validator: min, length: 5 },
            { validator: max, length: 20 },
        ],
        contact_number_2: [
            { validator: min, length: 5 },
            { validator: max, length: 20 },
        ],
        reg_no: [
            { validator: max, length: 150 },
        ],
        url: [
            { validator: max, length: 150 },
        ],
    },
};
